import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {AnalyticsService} from '../common/analytics.service';

@Component({
  selector: 'btc-donation',
  templateUrl: 'btc.component.html'
})
export class BtcDonationDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<BtcDonationDialogComponent>,
    private analytics: AnalyticsService) {
    this.analytics.action('showDonation');
  }

  close(): void {
    this.dialogRef.close();
  }
}
